module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0018.6006cd6e.jpg";